import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { nextStep, prevStep, jumpToStep } from '../../store/slices/stepBuilderSlice';

const Step = ({ component: Component, ...props }) => {
  const dispatch = useDispatch();
  const { current, total } = useSelector(state => state.stepBuilder);

  const navigation = {
    next: () => dispatch(nextStep()),
    prev: () => dispatch(prevStep()),
    jump: (step) => dispatch(jumpToStep(step)),
    current,
    total
  };

  return <Component {...props} {...navigation} />;
};

export default Step;